import { render, staticRenderFns } from "./SettingsPromoVideo.vue?vue&type=template&id=0d4b0c94&"
import script from "./SettingsPromoVideo.vue?vue&type=script&lang=js&"
export * from "./SettingsPromoVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports